import lauraAvatar from '@/assets/funnel28/laura-avatar.webp';
import quoteIcon from '@/assets/funnel28/quote.svg';
import clockIcon from '@/assets/funnel28/clock.svg';
import targetIcon from '@/assets/funnel28/target.svg';
import homeIcon from '@/assets/funnel28/home.svg';
import salaryIcon from '@/assets/funnel28/salary.svg';
import GoToQuizButton from './GoToQuizButton';

const stats = [
  { icon: clockIcon, label: 'Time to first interview', value: '7 days' },
  { icon: targetIcon, label: 'Weekly job search time', value: '<1 hr' },
  { icon: homeIcon, label: 'Flexible job secured', value: 'Remote' },
  { icon: salaryIcon, label: 'Salary increase', value: '24%' },
];

const ProofSection = () => {
  return (
    <section className="w-full pt-10 pb-12 md:py-20">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex flex-col md:grid md:grid-cols-3 md:items-stretch">
          <div className="flex flex-col justify-center gap-2 md:gap-4 mr-0 md:mr-10 mb-6 md:mb-0">
            <h2 className="text-[28px] md:text-[40px] font-bold leading-[1.15em] tracking-[-0.02em] text-[#1A1A1A]">
              What happens when job search is done right
            </h2>
            <p className="text-[15px] md:text-base leading-[1.5em] text-[#535353]">
              Faster offers, bigger raises, and happier jobs — here's what users are getting.
            </p>
          </div>
          <div className="flex flex-col bg-white border border-black/[0.08] border-b-0 md:border-r-0 md:border rounded-t-2xl p-5 md:p-6 md:rounded-r-none md:rounded-2xl">
            <div className="flex items-center gap-3 pb-5">
              <img src={lauraAvatar} alt="" className="w-[48px] h-[48px] rounded-full object-cover" />
              <div className="flex flex-col">
                <span className="font-semibold leading-[1.3em] text-[#1A1A1A]">Laura Miller</span>
                <span className="text-[14px] leading-[1.3em] text-[#535353]">Support Lead at Amazon</span>
                <div className="flex gap-0.5 mt-1" role="img" aria-label="Rated 5 out of 5 stars">
                  {[...Array(5)].map((_, i) => (
                    <svg
                      key={i}
                      aria-hidden="true"
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="#1A1A1A"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M7 0L8.5716 4.83688H13.6574L9.5429 7.82624L11.1145 12.6631L7 9.67376L2.8855 12.6631L4.4571 7.82624L0.3426 4.83688H5.4284L7 0Z" />
                    </svg>
                  ))}
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-4 pt-2">
              {stats.map((stat, i) => (
                <div key={i} className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <img src={stat.icon} alt="" className="w-6 h-6 flex-shrink-0" />
                    <span className="leading-[1.4em] text-[#333]">{stat.label}</span>
                  </div>
                  <span className="font-semibold leading-[1.4em]">{stat.value}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="bg-[#FFE7EB] rounded-b-2xl p-5 md:p-6 flex flex-col gap-3 h-full border border-black/[0.08] border-t-0 md:rounded-l-none md:rounded-2xl md:border-l-0 md:border">
            <div className="flex gap-0.5">
              <img src={quoteIcon} alt="" className="w-3 h-5" />
              <img src={quoteIcon} alt="" className="w-3 h-5" />
            </div>
            <p className="text-[#333]">
              "I was nervous about returning to work after spending two years at home with my kids. I didn't have the
              time or energy to apply to dozens of jobs. The platform handled applications for me and helped me prepare
              for interviews. Within a few weeks, I had multiple interviews and I found a role that fits my family
              life."
            </p>
          </div>
        </div>
        <div className="flex justify-center mt-6 md:mt-10">
          <GoToQuizButton className="w-full md:w-auto" funnelId={28} />
        </div>
      </div>
    </section>
  );
};

export default ProofSection;
